export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/9efedd6f8d84b8cf11b1862201b47d04.svg";